import React from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router';
import { scrollIntoView } from './utils/scroll_into_view';
import { isRestoringListScroll } from './utils/list_restoration';

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    // Trying to be as careful as possible.
    const loc0 = this.props.location;
    const loc1 = prevProps.location;
    if (!loc0 && !loc1) return;
    if (loc0 && loc1) {
      const key0 = loc0.key;
      const key1 = loc1.key;
      if (key0 === key1) return;
      // NEW: It is sufficient for pathnames to be the same for us to skip.
      // If pathnames remain the same, but query params change or hash params change, we skip the scrolling.
      if (loc0.pathname === loc1.pathname) return;
    }
    if (isRestoringListScroll()) return;
    if (this.props.scrollToElement) {
      scrollIntoView(this.props.scrollToElement);
    } else {
      // eslint-disable-next-line react/no-find-dom-node
      const node = ReactDOM.findDOMNode(this);
      if (node && node.scrollIntoView) node.scrollIntoView();
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
